import {SizeSelection_Size} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';
import {useActivatedCouponState} from '../../../../features/Coupons/useActivatedCouponState';
import {useProductIdFromSlug} from '../../../../features/ProductUrl';
import {useSizesSection as useSizesSectionMinimal} from '../../ProductInformationBox/MiniArticleDetail/useGetMinimalProductBulkSection';
import {useIsQuickView} from '../../QuickView/useIsQuickView';
import {useSizesSection} from '../../useGetProductBulkSection';

export const useTrackDetailPageWithReductions = (
  selectedSize?: SizeSelection_Size,
) => {
  const isQuickView = useIsQuickView();
  const useMinimalRequest = process.env.STACK === 'desktop' && isQuickView;
  const productId = useProductIdFromSlug();

  const request = useSizesSection({disabled: useMinimalRequest});
  const requestMinimal = useSizesSectionMinimal(
    productId!,
    undefined,
    !useMinimalRequest,
  );

  const {data: sizeSection} = useMinimalRequest ? requestMinimal : request;
  const productPrice = sizeSection?.price;
  const price =
    (selectedSize?.availability?.$case === 'inStock' &&
      selectedSize.availability.inStock.price) ||
    productPrice;

  const {activatedCoupon} = useActivatedCouponState(sizeSection?.product.id);

  const shouldTrackViewItemEvent = activatedCoupon
    ? Boolean(request.isFetched)
    : true;

  return {price, shouldTrackViewItemEvent};
};
